import {
  ConcatenateColumn,
  ConcatenateNode
} from 'types/transformation/types/nodes'

import { getColumnName } from '../utils'
import DataType from 'types/transformation/enums/DataType'

export const getNewColumn = (node: ConcatenateNode): ConcatenateColumn => {
  // get numbers at end of string
  const columnNumbers = node.columns.map((col) =>
    Number(col.id.match(/\d+$/)?.[0] ?? NaN)
  )
  const concatNumber = columnNumbers.length ? Math.max(...columnNumbers) + 1 : 0

  return {
    id: getColumnName(node.id, `concat_${concatNumber}`),
    name: '',
    reference_node: node.id,
    reference_node_index: node.index,
    left_column: null,
    right_column: null,
    delimiter: '-',
    type: DataType.STRING
  }
}
